/**
 * Shared Freeform Building types (P14.4) — the client contract.
 *
 * The client RENDERS replicated part/linkset/budget rows and CALLS the reducers;
 * every Land-Impact value, linkset rule, and budget check is server-authoritative.
 * Mirrors the server `freeform` tables.
 */

import type { IdentityHex } from './identity.js';

/** The parametric prim types a player can rez (mesh is via importMesh). */
export const REZ_PRIM_TYPES = ['box', 'sphere', 'cylinder', 'cone', 'torus'] as const;
export type RezPrimType = (typeof REZ_PRIM_TYPES)[number];

/** Linkset limits (Second-Life parity). */
export const LINKSET_MAX_PARTS = 256;
export const LINKSET_MAX_BBOX_M = 54;
export const LINKSET_MAX_PHYSICS_PARTS = 32;

/** A world's Land-Impact budget. Mirrors `world_build_budget`. */
export interface WorldBuildBudget {
  worldId: bigint;
  liMax: number;
  liUsed: number;
}

/** A rezzed part. Mirrors `part`. */
export interface Part {
  partId: bigint;
  worldId: bigint;
  linksetId: bigint;
  primType: string;
  meshRef: string;
  sourceAssetId: bigint;
  posX: number;
  posY: number;
  posZ: number;
  scaleX: number;
  scaleY: number;
  scaleZ: number;
  physics: boolean;
  landImpact: number;
}

// ─── Reducer argument types ──────────────────────────────────────────────────

export interface LinkPartsArgs {
  worldId: bigint;
  partIds: bigint[];
}
